import { useParams } from 'react-router'

import type { ReconciliationSpecRouteParams } from './types'

export const useSpecId = () => {
  const { specId } = useParams<ReconciliationSpecRouteParams>()

  if (!specId) {
    throw new Error('No spec ID was found')
  }

  return specId
}
